/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientModel { 
    id: number;
    phone: string;
    fullname?: string;
    birthDate?: string;
    countryId?: number;
    vip?: boolean;
    blacklisted?: boolean;
    note?: string;
}

